import { queryOptions, useQuery } from '@tanstack/react-query';

import { conversationsApi } from '../api/conversations-api';

import { conversationKeys } from './conversation-keys';

export function conversationCountsQueryOptions() {
  return queryOptions({
    queryKey: conversationKeys.counts(),
    queryFn: () => conversationsApi.counts(),
  });
}

/**
 * Open, pending, unassigned and mine per store. The inbox invalidates it on every socket frame;
 * elsewhere (the sidebar badge) it refreshes once a minute like the notification bell.
 */
export function useConversationCounts(
  options: { refetchIntervalMs?: number; enabled?: boolean } = {},
) {
  return useQuery({
    ...conversationCountsQueryOptions(),
    refetchInterval: options.refetchIntervalMs ?? false,
    enabled: options.enabled ?? true,
  });
}
